export default {
  getRepos: state => state.repoData,
}